module.exports = __webpack_public_path__ + "static/media/codeanywhere-glyph.829db678.svg";